const bodyLockClass = 'is-popup-open';
const openClass = 'is-open';
const transitionDuration = 240;

function setBodyLock() {
  const hasOpenPopup = document.querySelector('.js-popup:not([hidden]), .js-language-popup:not([hidden])');
  document.body.classList.toggle(bodyLockClass, Boolean(hasOpenPopup));
}

function getTemplate(key) {
  return Array.from(document.querySelectorAll('[data-popup-template]')).find((template) => {
    return template.dataset.popupTemplate === key;
  });
}

export function initContentPopup() {
  const popup = document.querySelector('.js-popup');

  if (!popup) {
    return;
  }

  const dialog = popup.querySelector('.js-popup-dialog');
  const title = popup.querySelector('.js-popup-title');
  const body = popup.querySelector('.js-popup-body');
  const closeButtons = popup.querySelectorAll('.js-popup-close, .js-popup-backdrop');
  let lastFocusedElement = null;
  let closeTimer = null;

  function closePopup() {
    window.clearTimeout(closeTimer);
    popup.classList.remove(openClass);

    closeTimer = window.setTimeout(() => {
      popup.hidden = true;
      popup.classList.remove('popup--long');
      setBodyLock();

      if (lastFocusedElement) {
        lastFocusedElement.focus();
        lastFocusedElement = null;
      }
    }, transitionDuration);
  }

  function openPopup(trigger) {
    const key = trigger.dataset.popupKey;
    const template = getTemplate(key);

    if (!template) {
      return;
    }

    lastFocusedElement = trigger;
    window.clearTimeout(closeTimer);
    title.textContent = template.dataset.popupTitle || trigger.textContent.trim();
    body.innerHTML = template.innerHTML;
    body.scrollTop = 0;

    const variant = trigger.dataset.popupVariant || template.dataset.popupVariant;
    popup.classList.toggle('popup--long', variant === 'long');
    popup.hidden = false;
    setBodyLock();
    window.requestAnimationFrame(() => {
      popup.classList.add(openClass);
      dialog.focus();
    });
  }

  document.querySelectorAll('.js-info-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => openPopup(trigger));
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden && popup.classList.contains(openClass)) {
      closePopup();
    }
  });
}
